export default __webpack_public_path__ + "static/media/actions-undo.68d080c3.svg";